export const isAdminUser = (user) => {
  if (!user || !user.role) return false;
  return user.role === "SuperUser" || user.role === "Admin";
};